module.exports = __webpack_public_path__ + "img/SUNGROW.4b35bed5.png";